export default __webpack_public_path__ + "static/media/Up.f8533e2b.png";